import{useEffect as n,useRef as a,useState as i}from"react";function l(t,r,o){const e=a(!1),[u,f]=i(!1);return n(()=>{e.current=!0},[]),n(()=>{if(!e.current||r)return f(!0),t();e.current=!1},o),u}export{l as useConditionalDidUpdateEffect};
